module.exports = __webpack_public_path__ + "static/media/citrics.c3e37c05.png";